// extracted by mini-css-extract-plugin
module.exports = {"root":"_f1750d","large":"_0f9775","reviewDisplay":"_dd5dd1"};